import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import { ChapterSubHeadline } from '../chapterComponents/ChapterSubHeadline';

type MobileFuellingImage = {
  image: string;
  alt: TranslationsKeys;
  className?: string;
};

export const ServicesMobileFuellingChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const driverAppImages: MobileFuellingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.servicesMobileFuelling1, locale),
      alt: 'userManual.chapter.services.mobileFuelling.image3Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesMobileFuelling2, locale),
      alt: 'userManual.chapter.services.mobileFuelling.image4Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesMobileFuelling3, locale),
      alt: 'userManual.chapter.services.mobileFuelling.image5Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesMobileFuelling4, locale),
      alt: 'userManual.chapter.services.mobileFuelling.image6Alt',
    },
  ];

  const driverAppTeaserImage = getImageAssetWithLocale(
    imageKeys.driverAppTeaser,
    locale,
  );

  const googleplayImages: MobileFuellingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.manPlayStoreQr, locale),
      alt: 'userManual.googleplayQRCodeImageAlt',
      className: 'border',
    },
    {
      image: getImageAssetWithLocale(imageKeys.playStore, locale),
      alt: 'userManual.googleplayImageAlt',
    },
  ];

  const appstoreImages: MobileFuellingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.manAppleStoreQr, locale),
      alt: 'userManual.appstoreImageAlt',
      className: 'border',
    },
    {
      image: getImageAssetWithLocale(imageKeys.appStore, locale),
      alt: 'userManual.appstoreQRCodeImageAlt',
    },
  ];

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.services.mobileFuelling.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterSubHeadline
            messageId={'userManual.chapter.services.mobileFuelling.subHeadline'}
          />
        </div>
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            className={'col-xs-12'}
            messageId={'userManual.chapter.services.mobileFuelling.text'}
          />
          <div className={'col-xs-12'}>
            <div className="col-xs-12 display-flex gap-10 padding-0">
              {driverAppImages.map(({ image, alt }) => {
                return (
                  <div
                    key={alt}
                    className={'col-xs-3 padding-0'}
                  >
                    <ImageLoader
                      className="border"
                      src={image}
                      alt={formatMessage({ id: alt })}
                      enlargeable
                    />
                  </div>
                );
              })}
            </div>

            <div className="col-xs-12 display-flex gap-10 padding-0 margin-top-20">
              <div className="col-xs-4 padding-0">
                <ImageLoader
                  className="border"
                  src={driverAppTeaserImage}
                  alt={formatMessage({
                    id: 'userManual.driverAppTeaserImageAlt',
                  })}
                  enlargeable
                />
              </div>
              <div className="col-xs-8">
                <div className="display-flex gap-10 flex-column">
                  {googleplayImages.map(({ image, alt, className }) => {
                    return (
                      <div
                        key={alt}
                        className={'col-xs-4 padding-0'}
                      >
                        <ImageLoader
                          className={className}
                          src={image}
                          alt={formatMessage({ id: alt })}
                          enlargeable
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="display-flex gap-10 margin-top-10 flex-column">
                  {appstoreImages.map(({ image, alt, className }) => {
                    return (
                      <div
                        key={alt}
                        className={'col-xs-4 padding-0'}
                      >
                        <ImageLoader
                          className={className}
                          src={image}
                          alt={formatMessage({ id: alt })}
                          enlargeable
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
